var ElementBase = require("../elementBase");
require("./president-results.less");
var dot = require("../../lib/dot");
var tableTemplate = dot.compile(require("./_table.html"));

var { formatTime, formatAPDate } = require("../utils");

var mugs = require("mugs.sheet.json");
var defaultFold = Object.keys(mugs).filter(n => mugs[n].featured).sort();
var defaultMax = 6;
var index = c => (defaultFold.indexOf(c.last) + 1) || (c.last == "Other" ? 101 : 100)

class PresidentResults extends ElementBase {

  constructor() {
    super();
    this.updated = null;
  }

  //override illuminate to add the button listener
  //this should still only happen once
  illuminate() {
    var elements = super.illuminate();
    elements.moreButton.addEventListener("click", () => this.toggleAttribute("expanded"));
    return elements;
  }

  static get observedAttributes() {
    return ["href", "headline"];
  }

  static get mirroredProps() {
    return ["href", "headline"];
  }

  attributeChangedCallback(attr, was, value) {
    var elements = this.illuminate();

    switch (attr) {
      case "headline":
        elements.headline.innerHTML = value ? value.trim() : "";
        break;

      case "href":
        elements.resultsLink.href = value;
        break;
    }
  }

  render(data) {
    var elements = this.illuminate();

    var result = data.results[0]; // only one for president
    var { caucus, footnote } = data;
    var { candidates, precincts, reporting, eevp, updated } = result;
    let photoCreditString = ""

    // copy the array before mutating
    candidates = candidates.slice();
    
    this.dispatch("updatedtime", { updated });

    this.setAttribute("party", data.party);
    // assign mugs and normalize percentages
    var hasIncumbent = false;
    var called = false
    candidates.forEach(function(c) {
      c.mugshot = mugs[c.last] ? mugs[c.last].src : "";
      c.percentage = c.percentage || 0;
      hasIncumbent = c.incumbent || hasIncumbent;
      called = !!c.winner || called;
    });

    elements.incumbency.style.display = hasIncumbent ? "" : "none";
    // check for existing votes
    candidates.sort((a, b) => b.percentage - a.percentage);
    // resort if no votes are cast
    var hasVotes = !!candidates[0].percentage;
    if (!hasVotes) {
      // sort by default view, then by name
      candidates.sort(function(a, b) {
        var aValue = index(a);
        var bValue = index(b);
        if (aValue == bValue) {
          return a.last < b.last ? -1 : 1;
        }
        return aValue - bValue;
      });
    }

    // filter small candidates into others
    var others = candidates.filter(c => c.last == "Other").pop();
    if (!others) {
      others = {
        last: "Other",
        votes: 0,
        percentage: 0
      };
      if (caucus) {
        others.caucus = 0;
      }
      candidates.push(others);
    }
    candidates = candidates.filter(function(c) {
      if (c.last != "Other" && c.percentage < 1 && defaultFold.indexOf(c.last) == -1) {
        others.percentage += c.percentage;
        others.votes += c.votes;
        if (c.caucus) others.caucus += c.caucus;
        return false;
      }
      return true;
    });
    if ((hasVotes || called) && !others.votes) {
      candidates = candidates.filter(c => c != others);
    }

    var max = this.getAttribute("max") || defaultMax;
    var fold = candidates.slice(0, max).map(c => c.last);

    // decide if we need overflow
    if (candidates.length > fold.length) {
      this.setAttribute("overflow", "");
    } else {
      this.removeAttribute("overflow");
    }

    // if we only have one candidate (uncontested) don't show county results
    elements.resultsLink.style.display = candidates.length < 2 ? "none" : "";

    // insert content
    var highest = Math.max(...result.candidates.map(r => r.percentage || 0));
    elements.content.innerHTML = tableTemplate({ candidates, highest, fold, caucus });

    // adjust reporting numbers

    if (reporting > 0 && eevp < 1) {
      eevp = "<1";
    } else if (reporting < precincts && eevp > 99 && eevp < 100) {
      eevp = ">99";
    } else {
      eevp = eevp.toFixed(0);
    }
    var updated = new Date(updated);
    var updateString = `as of ${formatTime(updated)} on ${formatAPDate(
      updated
    )}`;
    elements.updated.innerHTML = updateString;

    var reportingString = `${eevp}% of results in`;
    elements.reporting.innerHTML = reportingString;

    // add footnote if one exists (specified in `footnotes` sheet)
    if (footnote) {
      elements.footnote.innerHTML = `Note: ${ footnote }`;
    }
  }

  static get template() {
    return require("./_template.html");
  }

}

PresidentResults.define("president-results");